import { render, staticRenderFns } from "./DesignEditTabAccount.vue?vue&type=template&id=fb1771ba&"
import script from "./DesignEditTabAccount.vue?vue&type=script&lang=js&"
export * from "./DesignEditTabAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports